import { getModernTableStyles } from "../../Tables/modernTableStyles";

export const POS_REPORT_SCOPE = "pos-report-modern";

/**
 * POS Rapor ekranlarının stilleri: ortak liste stilleri (Ödeme Geçmişi / Ödeme
 * Linkleri ile aynı kaynak) + bu ekrana özgü tek düzeltme.
 */
export const getPosReportStyles = () => `
  ${getModernTableStyles(POS_REPORT_SCOPE)}

  /* Ortak stil, panel açılırken ana kolonu 100% → 66% arasında animasyonla
     daraltıyor. Ara karelerde ana kolon hâlâ geniş olduğu için yan kolon satıra
     sığmayıp alta düşüyor, animasyon bitince sağa zıplıyordu. Bu ekranda geçiş
     kapatılır: panel doğrudan konumunda açılır.
     Ek güvence olarak xl ve üstünde satırın sarmalaması engellenir; kolonlar
     gerekirse daralır (tablo zaten kendi içinde yatay kayar). */
  .${POS_REPORT_SCOPE} .ph-main,
  .${POS_REPORT_SCOPE} .ph-side { transition: none; }

  @media (min-width: 1200px) {
    .${POS_REPORT_SCOPE} .pos-report-row { flex-wrap: nowrap; }
    .${POS_REPORT_SCOPE} .pos-report-row > .ph-main,
    .${POS_REPORT_SCOPE} .pos-report-row > .ph-side { flex-shrink: 1; min-width: 0; }
  }
`;
